import axios from "axios";
import { SERVER_BASE_URL } from "../../constants/constants";


export const ImageService = {
    /**
     * Fetches image file.
     */
    getImgUrl(name: string) {
        const url = SERVER_BASE_URL + "api/home/img?name=" + name;
        return url;
    },


    async uploadImg(token: string, name: string, content: any) {
        const url = SERVER_BASE_URL + "api/home/img/upload";
        return axios({
            method: 'post',
            url: url,
            data: content,
            headers: {
                'x-auth-token': token,
                'Content-Type': `multipart/form-data; boundary=${content._boundary}`
            },
            params: {
                "name": name
            }
        });
    },
}